module.exports = __webpack_public_path__ + "assets/img/Nexon-4-Landing-Page-w720.7fd441bc.webp";